import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { CandidaturaService } from 'src/app/services/candidatura.service';
import { CargoService } from 'src/app/services/cargo.service';
import { PreCandidatosService } from 'src/app/services/precandidatos.service';
import { Utils } from 'src/app/utils/utils';
import { EleicaoService } from 'src/app/services/eleicao.service';
@Component({
  selector: 'app-lista-cargos',
  templateUrl: './lista-cargos.component.html',
  styleUrls: ['./lista-cargos.component.css']
})
export class ListaCargosAprovadorComponent implements OnInit {

  idEleicao: any;
  idAprovador: any;
  idCargo: any;
  cargos: any;
  candidatura:any;
  permissaoAprovador: boolean;
  infoAprovador: any;
  eleicao: any;
  token: string;

  constructor(
    protected router: Router,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private cargoService: CargoService,
    private candidaturaService: CandidaturaService,
    private preCandidatoService: PreCandidatosService,
    protected messageService: MessageService,
    public utils: Utils,
    public eleicaoService: EleicaoService,
    ) {
      this.idEleicao = +this.route.snapshot.params.idEleicao;
      this.idAprovador = +this.route.snapshot.params.idAprovador;
      this.idCargo = +this.route.snapshot.params.idCargo;
    }

  ngOnInit() {
    this.token = sessionStorage.getItem('token');
    this.infoAprovador = JSON.parse(sessionStorage.getItem('infoAprovador'));
    this.idEleicao = this.infoAprovador.idEleicao;
    this.idAprovador = this.infoAprovador.id;
    this.permissaoAprovador = this.infoAprovador.Role == "ROLE_APROVADOR";
    this.carregarCargos(this.idEleicao, this.token);
  }

  carregarCargos(idEleicao: any, token: string) {
    this.spinner.show();
    this.cargoService.getCargosByEleicao(idEleicao, token).subscribe(
      cargos => {
        this.cargos = cargos;
        this.spinner.hide();
      },
      error => {
        console.error('Erro ao recuperar cargos:', error);
        this.spinner.hide();
      }
    );
  }

  gerarRelatorioCandidaturas(){

    this.candidaturaService.listarPorIdEleicao(this.idEleicao, this.token).then(data => {
      this.candidatura = data;
      return this.preCandidatoService.getPreCandidatosByIdEleicao(this.candidatura.id, this.token);
    }).then(data => {
      this.utils.exportRelatorioCandidaturaSintetico(data);
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso', detail: "Relatório gerado!" });
    })
    .catch(error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Não foi possível gerar o relatório" });
    });

  }

  irParaCandidaturas(idCargo){
    this.spinner.show();
    sessionStorage.setItem("idCargo", idCargo);
    sessionStorage.setItem("idAprovador", this.idAprovador);
    sessionStorage.setItem("token", this.token);
    this.router.navigate(['../candidaturas'], {relativeTo: this.route});
    this.spinner.hide();
  }


}


